module.exports = __webpack_public_path__ + "img/table_1.2aca1be4.webp";